export const BreadCrumbContainerStyle = {
    marginBottom: '20px',
    marginTop: '20px',
    position: 'relative',
};
